/**
 * Public analytics API. Consumers should ONLY import from this module.
 *
 *   import { trackEvent, AnalyticsEvent } from '@/lib/analytics';
 *
 *   trackEvent(AnalyticsEvent.EVENT_SEARCH, { query: 'jazz', city: 'krakow' });
 */
import { analyticsConfig, isTrackingExcludedPath } from './config';
import { hasAnalyticsConsent } from './consent';
import { ga4Event, ga4PageView } from './ga4';
import { AnalyticsEvent, type AnalyticsEventName, type BaseEventParams } from './events';

export { AnalyticsEvent } from './events';
export type { AnalyticsEventName, BaseEventParams } from './events';
export { initAnalytics } from './loader';
export { notifyConsentChanged, hasAnalyticsConsent } from './consent';

/** Track a custom product event. No-op when consent is missing or path is excluded. */
export const trackEvent = (
  name: AnalyticsEventName | string,
  params: BaseEventParams = {},
): void => {
  if (typeof window === 'undefined') return;
  if (isTrackingExcludedPath(window.location.pathname)) return;
  if (!hasAnalyticsConsent()) {
    if (analyticsConfig.debug) console.debug('[analytics] suppressed (no consent):', name);
    return;
  }
  ga4Event(name, params);
};

/** Track an SPA page view. Called from useTrackPageView. */
export const trackPageView = (path: string, title?: string): void => {
  if (typeof window === 'undefined') return;
  if (isTrackingExcludedPath(path)) return;
  if (!hasAnalyticsConsent()) return;
  ga4PageView(path, title);
};
